// A manager's draft priorities, from the server, and the save.
// PLAN-2026-09-24 item B; the endpoints are BACKLOG D2's.
//
// TWO READS AND ONE WRITE, and the screen needs all three: the plan (what I
// want), the pool (who I can want — the league's own board, in its scoring),
// and the PUT that replaces the plan whole. `PUT` is a replacement, not a
// patch: a field left out goes back to its empty default, so the screen always
// sends the whole plan it is holding, limits included.

import {
  DraftPlanView,
  DraftPoolView,
  DraftView,
  type ManualDraftRequest,
  type SaveDraftPlanRequest,
} from '@fsp/domain';
import { send, type Reply } from './api';
import { thenRefresh } from './moves';
import { useRead, type Read } from './read';

export function useDraftPlan(leagueId: string | null): Read<DraftPlanView | null> {
  return useRead(leagueId === null ? null : `/leagues/${leagueId}/draft/plan`, DraftPlanView);
}

export function useDraftPool(leagueId: string | null): Read<DraftPoolView | null> {
  return useRead(leagueId === null ? null : `/leagues/${leagueId}/draft/pool`, DraftPoolView);
}

/** Save the whole plan. `submit` marks it ready as well; that cannot be undone. */
export function saveDraftPlan(
  leagueId: string,
  body: SaveDraftPlanRequest,
): Promise<Reply<DraftPlanView>> {
  return send('PUT', `/leagues/${leagueId}/draft/plan`, body, DraftPlanView);
}

/**
 * One step of a draft held in person, entered by the commissioner (D7): the
 * order, a pick, taking the last one back, or finishing. Answers with the
 * draft as `GET …/draft` serves it, and asks the league's reads again after,
 * since a finish changes every roster.
 */
export function enterDraft(leagueId: string, body: ManualDraftRequest): Promise<Reply<DraftView>> {
  return thenRefresh(leagueId, send('POST', `/leagues/${leagueId}/draft/manual`, body, DraftView));
}
